var _, addQuickFilter, capitalize, changePage, changeSort, filter, getRequests, jQuery, pageSize, renderPager, renderRequests, rowTemplate, setupEvents, sprintf, ui, util;

jQuery = require('jquery');

_ = require('underscore');

capitalize = require('underscore.string/capitalize');

sprintf = (require('sprintf-js')).sprintf;

util = require('evesrp/util');

ui = require('evesrp/common-ui');

filter = require('evesrp/filter');

rowTemplate = require('evesrp/templates/request_row');

pageSize = 15;

renderRequests = function(data) {
  var $headers, $oldRows, $rows, $summary, $table, columns, formatsPromise, header;
  $rows = (jQuery('table#requests tr')).not(jQuery('.popover tr'));
  $table = $rows.parent();
  formatsPromise = ui.setupFormats();
  $headers = $rows.first().find('th');
  $oldRows = $rows.not(':first');
  columns = (function() {
    var i, len, results;
    results = [];
    for (i = 0, len = $headers.length; i < len; i++) {
      header = $headers[i];
      results.push(((jQuery(header)).attr('id')).slice(4));
    }
    return results;
  })();
  formatsPromise.done(function() {
    var $row, column, context, currency, filterable, i, j, len, len1, ref, request, statusColor, value;
    if ($oldRows.length !== 0) {
      $oldRows.remove();
    }
    ref = data.requests;
    for (i = 0, len = ref.length; i < len; i++) {
      request = ref[i];
      statusColor = util.statusColor(request.status);
      $row = jQuery("<tr class=\"" + statusColor + "\"></tr>");
      for (j = 0, len1 = columns.length; j < len1; j++) {
        column = columns[j];
        filterable = column === 'pilot' || column === 'ship' || column === 'system' || column === 'status';
        value = (function() {
          switch (column) {
            case 'status':
              return capitalize(request.status);
            case 'pilot':
            case 'division':
              return request[column].name;
            case 'payout':
            case 'base_payout':
              currency = parseFloat(request[column]);
              return ui.currencyFormat(currency);
            case 'submit_timestamp':
            case 'kill_timestamp':
              return ui.dateFormatShort(util.localToUTC(request[column]));
            default:
              return request[column];
          }
        })();
        context = {
          value: value,
          attribute: column,
          filterable: filterable
        };
        if (column === 'id') {
          context.link = request.href;
        }
        $row.append(rowTemplate(context));
      }
      $table.append($row);
    }
    return ($table.find('.filterable a')).on('click', addQuickFilter);
  });
  $summary = jQuery('#requestsSummary');
  return (jQuery.when(formatsPromise, ui.setupTranslations())).done(function() {
    var request_count, requests_slug, requests_text, total_payouts;
    request_count = ui.numberFormat(data.request_count);
    total_payouts = ui.currencyFormat(parseFloat(data.total_payouts));
    requests_slug = ui.i18n.ngettext('%(num)s request', '%(num)s requests', data.request_count);
    requests_text = sprintf(requests_slug, {
      num: request_count
    });
    return $summary.text(requests_text + " • " + total_payouts + " ISK");
  });
};

renderPager = function(data, currentFilters) {
  var $pager, i, len, newPath, numPages, pageNum, ref, tempFilters;
  $pager = jQuery('ul.pagination');
  numPages = (Math.ceil(data.request_count / pageSize - 1)) + 1;
  tempFilters = JSON.parse(JSON.stringify(currentFilters));
  $pager.empty();
  if (numPages > 1) {
    $pager.removeClass('hidden');
    if (currentFilters.page === 1) {
      $pager.append('<li class="disabled"><span>&laquo;</span></li>');
    } else {
      tempFilters.page = currentFilters.page - 1;
      newPath = filter.unParseFilters(tempFilters);
      $pager.append("<li><a id=\"prev_page\" href=\"" + newPath + "\">&laquo;</a></li>");
    }
    ref = util.pageNumbers(numPages, currentFilters.page);
    for (i = 0, len = ref.length; i < len; i++) {
      pageNum = ref[i];
      if (pageNum !== null) {
        tempFilters.page = pageNum;
        newPath = filter.unParseFilters(tempFilters);
        if (pageNum !== currentFilters.page) {
          $pager.append("<li><a href=\"" + newPath + "\">" + pageNum + " </a></li>");
        } else {
          $pager.append("<li class=\"active\"> <a href=\"" + newPath + "\">" + pageNum + " <span class=\"sr-only\" (current)</span> </a></li>");
        }
      } else {
        $pager.append('<li class="disabled"><span>&hellip;</span></li>');
      }
    }
    if (currentFilters.page === numPages) {
      return $pager.append('<li class="disabled"><span>&raquo;</span></li>');
    } else {
      tempFilters.page = currentFilters.page + 1;
      newPath = filter.unParseFilters(tempFilters);
      return $pager.append("<li><a id=\"next_page\" href=\"" + newPath + "\">&raquo;</a></li>");
    }
  } else {
    return $pager.addClass('hidden');
  }
};

getRequests = function() {
  var urlPath;
  urlPath = window.location.pathname;
  return jQuery.ajax({
    type: 'GET',
    url: urlPath,
    success: function(data) {
      var filters;
      filters = filter.getFilters();
      renderRequests(data);
      return renderPager(data, filters);
    }
  });
};

changeSort = function(ev) {
  var $allHeaders, $target, $targetHeader, colName, filters;
  $target = jQuery(ev.target);
  $targetHeader = $target.parent('th');
  colName = ($targetHeader.attr('id')).slice(4);
  if (colName === 'None') {
    return false;
  }
  filters = filter.getFilters();
  if (filters.sort === colName) {
    filters.sort = "-" + colName;
  } else {
    filters.sort = colName;
  }
  $allHeaders = $targetHeader.parent().children('th');
  ($allHeaders.find('i.fa')).removeClass();
  if ((filters.sort.charAt(0)) === '-') {
    ($target.find('i')).addClass('fa fa-chevron-down');
  } else {
    ($target.find('i')).addClass('fa fa-chevron-up');
  }
  filter.updateURL(filters);
  return false;
};

changePage = function(ev) {
  var $target;
  $target = jQuery(ev.target);
  filter.updateURL($target.attr('href'));
  return false;
};

addQuickFilter = function(ev) {
  var $cell, attribute, selectize, value;
  $cell = (jQuery(ev.target)).closest('td');
  attribute = $cell.data('attribute');
  value = $cell.text();
  if (attribute === 'status') {
    value = value.toLowerCase();
  }
  selectize = (jQuery('.filter-tokenfield'))[0].selectize;
  ui.setupTranslations().done(function() {
    var translatedAttribute;
    translatedAttribute = ui.attributeGettext(attribute);
    return selectize.addItem(translatedAttribute + ":=" + value, false);
  });
  return false;
};

setupEvents = function() {
  var $window;
  (jQuery('th a.heading')).on('click', changeSort);
  (jQuery('ul.pagination')).on('click', 'a', changePage);
  (jQuery('.filterable a')).on('click', addQuickFilter);
  $window = jQuery(window);
  $window.on('popstate', getRequests);
  return $window.on('evesrp:filterchange', getRequests);
};

exports.setupEvents = setupEvents;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2hvbWUvdGhvbWFzL0RvY3VtZW50cy9wcm9qZWN0cy9ldmVzcnAvc3JjL2V2ZXNycC9zdGF0aWMvanMvcmVxdWVzdExpc3QuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL2hvbWUvdGhvbWFzL0RvY3VtZW50cy9wcm9qZWN0cy9ldmVzcnAvc3JjL2V2ZXNycC9zdGF0aWMvanMvcmVxdWVzdExpc3QuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsTUFBQSxHQUFTLE9BQUEsQ0FBUSxRQUFSOztBQUNULENBQUEsR0FBSSxPQUFBLENBQVEsWUFBUjs7QUFDSixVQUFBLEdBQWEsT0FBQSxDQUFRLDhCQUFSOztBQUNiLE9BQUEsR0FBVSxDQUFDLE9BQUEsQ0FBUSxZQUFSLENBQUQsQ0FBc0IsQ0FBQzs7QUFDakMsSUFBQSxHQUFPLE9BQUEsQ0FBUSxhQUFSOztBQUNQLEVBQUEsR0FBSyxPQUFBLENBQVEsa0JBQVI7O0FBQ0wsTUFBQSxHQUFTLE9BQUEsQ0FBUSxlQUFSOztBQUNULFdBQUEsR0FBYyxPQUFBLENBQVEsOEJBQVI7O0FBR2QsUUFBQSxHQUFXOztBQUdYLGNBQUEsR0FBaUIsU0FBQyxJQUFEO0FBQ2IsTUFBQTtFQUFBLEtBQUEsR0FBUSxDQUFDLE1BQUEsQ0FBTyxtQkFBUCxDQUFELENBQTRCLENBQUMsR0FBN0IsQ0FBa0MsTUFBQSxDQUFPLGFBQVAsQ0FBbEM7RUFDUixNQUFBLEdBQVMsS0FBSyxDQUFDLE1BQU4sQ0FBQTtFQUNULGNBQUEsR0FBaUIsRUFBRSxDQUFDLFlBQUgsQ0FBQTtFQUVqQixRQUFBLEdBQVcsS0FBSyxDQUFDLEtBQU4sQ0FBQSxDQUFhLENBQUMsSUFBZCxDQUFtQixJQUFuQjtFQUNYLFFBQUEsR0FBVyxLQUFLLENBQUMsR0FBTixDQUFVLFFBQVY7RUFFWCxPQUFBOztBQUFVO1NBQUEsMENBQUE7O21CQUNOLENBQUMsQ0FBQyxNQUFBLENBQU8sTUFBUCxDQUFELENBQWUsQ0FBQyxJQUFoQixDQUFxQixJQUFyQixDQUFELENBQTRCO0FBRHRCOzs7RUFFVixjQUFjLENBQUMsSUFBZixDQUFvQixTQUFBO0FBQ2hCLFFBQUE7SUFBQSxJQUFPLFFBQVEsQ0FBQyxNQUFULEtBQW1CLENBQTFCO01BQ0ksUUFBUSxDQUFDLE1BQVQsQ0FBQSxFQURKOztBQUVBO0FBQUEsU0FBQSxxQ0FBQTs7TUFDSSxXQUFBLEdBQWMsSUFBSSxDQUFDLFdBQUwsQ0FBaUIsT0FBTyxDQUFDLE1BQXpCO01BQ2QsSUFBQSxHQUFPLE1BQUEsQ0FBTyxjQUFBLEdBQWdCLFdBQWhCLEdBQTZCLFVBQXBDO0FBQ1AsV0FBQSwyQ0FBQTs7UUFDSSxVQUFBLEdBQWEsTUFBQSxLQUFXLE9BQVgsSUFBQSxNQUFBLEtBQW9CLE1BQXBCLElBQUEsTUFBQSxLQUE0QixRQUE1QixJQUFBLE1BQUEsS0FBc0M7UUFDbkQsS0FBQTtBQUFRLGtCQUFPLE1BQVA7QUFBQSxpQkFDQyxRQUREO3FCQUNlLFVBQUEsQ0FBVyxPQUFPLENBQUMsTUFBbkI7QUFEZixpQkFFQyxPQUZEO0FBQUEsaUJBRVUsVUFGVjtxQkFFMEIsT0FBUSxDQUFBLE1BQUEsQ0FBTyxDQUFDO0FBRjFDLGlCQUdDLFFBSEQ7QUFBQSxpQkFHVyxhQUhYO2NBSUEsUUFBQSxHQUFXLFVBQUEsQ0FBVyxPQUFRLENBQUEsTUFBQSxDQUFuQjtxQkFDWCxFQUFFLENBQUMsY0FBSCxDQUFrQixRQUFsQjtBQUxBLGlCQU1DLGtCQU5EO0FBQUEsaUJBTXFCLGdCQU5yQjtxQkFPQSxFQUFFLENBQUMsZUFBSCxDQUFvQixJQUFJLENBQUMsVUFBTCxDQUFnQixPQUFRLENBQUEsTUFBQSxDQUF4QixDQUFwQjtBQVBBO3FCQVFDLE9BQVEsQ0FBQSxNQUFBO0FBUlQ7O1FBU1IsT0FBQSxHQUFVO1VBQ04sS0FBQSxFQUFPLEtBREQ7VUFFTixTQUFBLEVBQVcsTUFGTDtVQUdOLFVBQUEsRUFBWSxVQUhOOztRQUtWLElBQUcsTUFBQSxLQUFVLElBQWI7VUFDSSxPQUFPLENBQUMsSUFBUixHQUFlLE9BQU8sQ0FBQyxLQUQzQjs7UUFFQSxJQUFJLENBQUMsTUFBTCxDQUFZLFdBQUEsQ0FBWSxPQUFaLENBQVo7QUFsQko7TUFtQkEsTUFBTSxDQUFDLE1BQVAsQ0FBYyxJQUFkO0FBdEJKO1dBd0JBLENBQUMsTUFBTSxDQUFDLElBQVAsQ0FBWSxlQUFaLENBQUQsQ0FBNkIsQ0FBQyxFQUE5QixDQUFpQyxPQUFqQyxFQUEwQyxjQUExQztFQTNCZ0IsQ0FBcEI7RUE2QkEsUUFBQSxHQUFXLE1BQUEsQ0FBTyxrQkFBUDtTQUNYLENBQUMsTUFBTSxDQUFDLElBQVAsQ0FBWSxjQUFaLEVBQTRCLEVBQUUsQ0FBQyxpQkFBSCxDQUFBLENBQTVCLENBQUQsQ0FBb0QsQ0FBQyxJQUFyRCxDQUEwRCxTQUFBO0FBQ3RELFFBQUE7SUFBQSxhQUFBLEdBQWdCLEVBQUUsQ0FBQyxZQUFILENBQWdCLElBQUksQ0FBQyxhQUFyQjtJQUNoQixhQUFBLEdBQWdCLEVBQUUsQ0FBQyxjQUFILENBQW1CLFVBQUEsQ0FBVyxJQUFJLENBQUMsYUFBaEIsQ0FBbkI7SUFDaEIsYUFBQSxHQUFnQixFQUFFLENBQUMsSUFBSSxDQUFDLFFBQVIsQ0FBaUIsaUJBQWpCLEVBQW9DLGtCQUFwQyxFQUNaLElBQUksQ0FBQyxhQURPO0lBRWhCLGFBQUEsR0FBZ0IsT0FBQSxDQUFRLGFBQVIsRUFBdUI7TUFBRSxHQUFBLEVBQUssYUFBUDtLQUF2QjtXQUNoQixRQUFRLENBQUMsSUFBVCxDQUFrQixhQUFGLEdBQWlCLEtBQWpCLEdBQXVCLGFBQXZCLEdBQXNDLE1BQXREO0VBTnNELENBQTFEO0FBeENhOztBQWlEakIsV0FBQSxHQUFjLFNBQUMsSUFBRCxFQUFPLGNBQVA7QUFDVixNQUFBO0VBQUEsTUFBQSxHQUFTLE1BQUEsQ0FBTyxlQUFQO0VBQ1QsUUFBQSxHQUFXLENBQUMsSUFBSSxDQUFDLElBQUwsQ0FBVyxJQUFJLENBQUMsYUFBTCxHQUFxQixRQUFyQixHQUFnQyxDQUEzQyxDQUFELENBQUEsR0FBa0Q7RUFDN0QsV0FBQSxHQUFjLElBQUksQ0FBQyxLQUFMLENBQVksSUFBSSxDQUFDLFNBQUwsQ0FBZSxjQUFmLENBQVo7RUFDZCxNQUFNLENBQUMsS0FBUCxDQUFBO0VBQ0EsSUFBRyxRQUFBLEdBQVcsQ0FBZDtJQUNJLE1BQU0sQ0FBQyxXQUFQLENBQW1CLFFBQW5CO0lBRUEsSUFBRyxjQUFjLENBQUMsSUFBZixLQUF1QixDQUExQjtNQUNJLE1BQU0sQ0FBQyxNQUFQLENBQWMsZ0RBQWQsRUFESjtLQUFBLE1BQUE7TUFHSSxXQUFXLENBQUMsSUFBWixHQUFtQixjQUFjLENBQUMsSUFBZixHQUFzQjtNQUN6QyxPQUFBLEdBQVUsTUFBTSxDQUFDLGNBQVAsQ0FBc0IsV0FBdEI7TUFDVixNQUFNLENBQUMsTUFBUCxDQUFjLGlDQUFBLEdBQW1DLE9BQW5DLEdBQTRDLHFCQUExRCxFQUxKOztBQU9BO0FBQUEsU0FBQSxxQ0FBQTs7TUFDSSxJQUFPLE9BQUEsS0FBVyxJQUFsQjtRQUNJLFdBQVcsQ0FBQyxJQUFaLEdBQW1CO1FBQ25CLE9BQUEsR0FBVSxNQUFNLENBQUMsY0FBUCxDQUFzQixXQUF0QjtRQUNWLElBQU8sT0FBQSxLQUFXLGNBQWMsQ0FBQyxJQUFqQztVQUNJLE1BQU0sQ0FBQyxNQUFQLENBQWMsZ0JBQUEsR0FBa0IsT0FBbEIsR0FBMkIsS0FBM0IsR0FBaUMsT0FBakMsR0FBMEMsWUFBeEQsRUFESjtTQUFBLE1BQUE7VUFLSSxNQUFNLENBQUMsTUFBUCxDQUFjLGtDQUFBLEdBQ2MsT0FEZCxHQUN1QixLQUR2QixHQUM2QixPQUQ3QixHQUNzQyxxREFEcEQsRUFMSjtTQUhKO09BQUEsTUFBQTtRQWNJLE1BQU0sQ0FBQyxNQUFQLENBQWMsaURBQWQsRUFkSjs7QUFESjtJQWlCQSxJQUFHLGNBQWMsQ0FBQyxJQUFmLEtBQXVCLFFBQTFCO2FBQ0ksTUFBTSxDQUFDLE1BQVAsQ0FBYyxnREFBZCxFQURKO0tBQUEsTUFBQTtNQUdJLFdBQVcsQ0FBQyxJQUFaLEdBQW1CLGNBQWMsQ0FBQyxJQUFmLEdBQXNCO01BQ3pDLE9BQUEsR0FBVSxNQUFNLENBQUMsY0FBUCxDQUFzQixXQUF0QjthQUNWLE1BQU0sQ0FBQyxNQUFQLENBQWMsaUNBQUEsR0FBbUMsT0FBbkMsR0FBNEMscUJBQTFELEVBTEo7S0EzQko7R0FBQSxNQUFBO1dBbUNJLE1BQU0sQ0FBQyxRQUFQLENBQWdCLFFBQWhCLEVBbkNKOztBQUxVOztBQTJDZCxXQUFBLEdBQWMsU0FBQTtBQUNWLE1BQUE7RUFBQSxPQUFBLEdBQVUsTUFBTSxDQUFDLFFBQVEsQ0FBQztTQUMxQixNQUFNLENBQUMsSUFBUCxDQUFZO0lBQ1IsSUFBQSxFQUFNLEtBREU7SUFFUixHQUFBLEVBQUssT0FGRztJQUdSLE9BQUEsRUFBUyxTQUFDLElBQUQ7QUFDTCxVQUFBO01BQUEsT0FBQSxHQUFVLE1BQU0sQ0FBQyxVQUFQLENBQUE7TUFDVixjQUFBLENBQWUsSUFBZjthQUNBLFdBQUEsQ0FBWSxJQUFaLEVBQWtCLE9BQWxCO0lBSEssQ0FIRDtHQUFaO0FBRlU7O0FBWWQsVUFBQSxHQUFhLFNBQUMsRUFBRDtBQUNULE1BQUE7RUFBQSxPQUFBLEdBQVUsTUFBQSxDQUFPLEVBQUUsQ0FBQyxNQUFWO0VBQ1YsYUFBQSxHQUFnQixPQUFPLENBQUMsTUFBUixDQUFlLElBQWY7RUFDaEIsT0FBQSxHQUFVLENBQUMsYUFBYSxDQUFDLElBQWQsQ0FBbUIsSUFBbkIsQ0FBRCxDQUEwQjtFQUVwQyxJQUFHLE9BQUEsS0FBVyxNQUFkO0FBQ0ksV0FBTyxNQURYOztFQUtBLE9BQUEsR0FBVSxNQUFNLENBQUMsVUFBUCxDQUFBO0VBQ1YsSUFBRyxPQUFPLENBQUMsSUFBUixLQUFnQixPQUFuQjtJQUNJLE9BQU8sQ0FBQyxJQUFSLEdBQWUsR0FBQSxHQUFLLFFBRHhCO0dBQUEsTUFBQTtJQUdJLE9BQU8sQ0FBQyxJQUFSLEdBQWUsUUFIbkI7O0VBS0EsV0FBQSxHQUFjLGFBQWEsQ0FBQyxNQUFkLENBQUEsQ0FBc0IsQ0FBQyxRQUF2QixDQUFnQyxJQUFoQztFQUNkLENBQUMsV0FBVyxDQUFDLElBQVosQ0FBaUIsTUFBakIsQ0FBRCxDQUF5QixDQUFDLFdBQTFCLENBQUE7RUFDQSxJQUFHLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxNQUFiLENBQW9CLENBQXBCLENBQUQsQ0FBQSxLQUEyQixHQUE5QjtJQUNJLENBQUMsT0FBTyxDQUFDLElBQVIsQ0FBYSxHQUFiLENBQUQsQ0FBa0IsQ0FBQyxRQUFuQixDQUE0QixvQkFBNUIsRUFESjtHQUFBLE1BQUE7SUFHSSxDQUFDLE9BQU8sQ0FBQyxJQUFSLENBQWEsR0FBYixDQUFELENBQWtCLENBQUMsUUFBbkIsQ0FBNEIsa0JBQTVCLEVBSEo7O0VBSUEsTUFBTSxDQUFDLFNBQVAsQ0FBaUIsT0FBakI7U0FDQTtBQXZCUzs7QUEwQmIsVUFBQSxHQUFhLFNBQUMsRUFBRDtBQUNULE1BQUE7RUFBQSxPQUFBLEdBQVUsTUFBQSxDQUFPLEVBQUUsQ0FBQyxNQUFWO0VBQ1YsTUFBTSxDQUFDLFNBQVAsQ0FBa0IsT0FBTyxDQUFDLElBQVIsQ0FBYSxNQUFiLENBQWxCO1NBQ0E7QUFIUzs7QUFNYixjQUFBLEdBQWlCLFNBQUMsRUFBRDtBQUNiLE1BQUE7RUFBQSxLQUFBLEdBQVEsQ0FBQyxNQUFBLENBQU8sRUFBRSxDQUFDLE1BQVYsQ0FBRCxDQUFrQixDQUFDLE9BQW5CLENBQTJCLElBQTNCO0VBQ1IsU0FBQSxHQUFZLEtBQUssQ0FBQyxJQUFOLENBQVcsV0FBWDtFQUNaLEtBQUEsR0FBUSxLQUFLLENBQUMsSUFBTixDQUFBO0VBQ1IsSUFBRyxTQUFBLEtBQWEsUUFBaEI7SUFDSSxLQUFBLEdBQVEsS0FBSyxDQUFDLFdBQU4sQ0FBQSxFQURaOztFQUVBLFNBQUEsR0FBWSxDQUFDLE1BQUEsQ0FBTyxvQkFBUCxDQUFELENBQThCLENBQUEsQ0FBQSxDQUFFLENBQUM7RUFHN0MsRUFBRSxDQUFDLGlCQUFILENBQUEsQ0FBc0IsQ0FBQyxJQUF2QixDQUE0QixTQUFBO0FBQ3hCLFFBQUE7SUFBQSxtQkFBQSxHQUFzQixFQUFFLENBQUMsZ0JBQUgsQ0FBb0IsU0FBcEI7V0FDdEIsU0FBUyxDQUFDLE9BQVYsQ0FBc0IsbUJBQUYsR0FBdUIsSUFBdkIsR0FBNEIsS0FBaEQsRUFBMEQsS0FBMUQ7RUFGd0IsQ0FBNUI7U0FHQTtBQVphOztBQWVqQixXQUFBLEdBQWMsU0FBQTtBQUNWLE1BQUE7RUFBQSxDQUFDLE1BQUEsQ0FBTyxjQUFQLENBQUQsQ0FBdUIsQ0FBQyxFQUF4QixDQUEyQixPQUEzQixFQUFvQyxVQUFwQztFQUNBLENBQUMsTUFBQSxDQUFPLGVBQVAsQ0FBRCxDQUF3QixDQUFDLEVBQXpCLENBQTRCLE9BQTVCLEVBQXFDLEdBQXJDLEVBQTBDLFVBQTFDO0VBQ0EsQ0FBQyxNQUFBLENBQU8sZUFBUCxDQUFELENBQXdCLENBQUMsRUFBekIsQ0FBNEIsT0FBNUIsRUFBcUMsY0FBckM7RUFDQSxPQUFBLEdBQVUsTUFBQSxDQUFPLE1BQVA7RUFDVixPQUFPLENBQUMsRUFBUixDQUFXLFVBQVgsRUFBdUIsV0FBdkI7U0FDQSxPQUFPLENBQUMsRUFBUixDQUFXLHFCQUFYLEVBQWtDLFdBQWxDO0FBTlU7O0FBU2QsT0FBTyxDQUFDLFdBQVIsR0FBc0IifQ==
